/**
 *  Return default state for setup stored
 * @returns { object} Default state object
 */
export function getDefaultState() {
  return {
    driveMap: {},
    driveBreadCrumbMap: {},
    driveRootItemIdMap: {},
    driveRootDisplayNameMap: {},
    driveTypeMap: {},

    sharePointGroupMembership: {},

    templateMap: {},
    sectionRootDriveSettingMap: {},

    driveItemsSharedWithMe: [],

    searchSetMap: {} // { driveId: { itemId, searchTerm, searchResults }}
  };
}

const immutableState = { myDriveRootId: "", myDrives: {} };

const state = Object.assign(immutableState, getDefaultState());

export default state;
